import { createActionsHook, createHook, createStateHook, createStore } from 'react-sweet-state';

// The entry point that triggered the staging area.
export type StagingAreaEntryPoint =
	| 'globalCreateDropdown-smartCreate'
	| 'spaceLevelContextualCreate-smartCreate'
	| 'pageTreeItemContextualCreate-smartCreate'
	| 'endOfContentTreeContextualCreate-smartCreate'
	| 'poConfluenceSideNavCreate'
	| 'whiteboardToLiveDocAiConversion'
	| 'rovoChatPreviewCard'
	| 'jiraCreateWithAIDropdown'
	| 'rovoChat';

type StagingAreaState = {
	/**
	 * ID of the LLM generated content that is being previewed in the staging area.
	 */
	messageIdSelectedForPreview: string | null;
	/**
	 * How the staging area should be displayed.
	 */
	stagingAreaMode: 'inline' | 'modal' | undefined;

	stagingAreaEntryPoint: StagingAreaEntryPoint | '';
	/** String representation of the user's prompt  */
	prompt: string;
};

const initialState: StagingAreaState = {
	messageIdSelectedForPreview: null,
	stagingAreaMode: undefined,
	stagingAreaEntryPoint: '',
	prompt: '',
};

const actions = {
	setMessageIdSelectedForPreview:
		(messageId: string | null) =>
		({ setState }: { setState: (state: Partial<StagingAreaState>) => void }) => {
			setState({
				messageIdSelectedForPreview: messageId,
			});
		},
	getMessageIdSelectedForPreview:
		() =>
		({ getState }: { getState: () => StagingAreaState }) => {
			return getState().messageIdSelectedForPreview;
		},
	setStagingAreaMode:
		(mode: 'inline' | 'modal' | undefined, entryPoint: StagingAreaEntryPoint | undefined) =>
		({ setState }: { setState: (state: Partial<StagingAreaState>) => void }) => {
			setState({
				stagingAreaMode: mode,
				stagingAreaEntryPoint: entryPoint,
			});
		},
	setPrompt:
		(prompt: string) =>
		({ setState }: { setState: (state: Partial<StagingAreaState>) => void }) => {
			setState({
				prompt,
			});
		},
};

const store = createStore({
	initialState,
	actions,
});

export const useMessageIdSelectedForPreview = createHook(store, {
	selector: (state: StagingAreaState) => state.messageIdSelectedForPreview,
});

export const useStagingArea = createHook(store);
export const useStagingAreaActions = createActionsHook(store);
export const useStagingAreaState = createStateHook(store);
